<template>
    <div :class="{compare: this.needSync}">
        <video type="video" :class="needSync ? 'vjs-1-1' : 'vjs-16-9'"
               class="video-js vjs-big-play-centered rowing-video-player"
               v-bind="{'playsinline': this.needSync}"
               width="100%" ref="RowingVideoPlayer"></video>
    </div>
</template>

<!--suppress ES6ConvertVarToLetConst -->
<script>
    import videojs from 'video.js'
    import {Decimal} from 'decimal.js'
    import {sleep} from "@/scripts/utils";
    import fileUtils from "@/mixins/file-utils"
    import {createDrawingOverlay} from "@/scripts/video-drawing-overlay";

    const DEBUG = false;

    function round(num, decimalPlaces = 0) {
        return new Decimal(num).toDecimalPlaces(decimalPlaces).toNumber();
    }

    function getAllIndices(arr, val) {
        var indexes = [], i;
        for(i = 0; i < arr.length; i++)
            if (arr[i] === val)
                indexes.push(i)
        return indexes;
    }

    function frameNumToTime(frameNum, fps, noShift) {
        let res = frameNum*(1/fps)
        if (!noShift)
            res += 1/fps/5
        return res
    }

    function timeToFrameNum(time, fps) {
        return Math.floor(time * fps)
    }

    var VjsButton = videojs.getComponent('Button')
    var FBFButton = videojs.extend(VjsButton, {
        constructor: function (player, options) {
            this.VjsPlayer = player
            this.fps = options.fps
            this.stepFramesQty = options.stepFramesQty
            this.videoFramesSchema = options.videoFramesSchema
            VjsButton.call(this, this.VjsPlayer, options)
        },

        handleClick: function () {
            if (!this.VjsPlayer.paused())
                this.VjsPlayer.controlBar.playToggle.el().click()
            else {
                let currentFrameNum = timeToFrameNum(this.VjsPlayer.currentTime(), this.fps)

                let dstFrameNum = currentFrameNum + this.stepFramesQty
                if (dstFrameNum < 0)
                    dstFrameNum = 0

                if (this.videoFramesSchema) {
                    let currentFrameBaseVideoNum = this.videoFramesSchema[currentFrameNum]
                    // eslint-disable-next-line no-constant-condition
                    while (true) {
                        if (dstFrameNum >= this.videoFramesSchema.length) {
                            dstFrameNum = this.videoFramesSchema.length - 1
                            break
                        }
                        if (dstFrameNum < 0) {
                            dstFrameNum = 0
                            break
                        }

                        let dstFrameBaseVideoNum = this.videoFramesSchema[dstFrameNum]

                        if (currentFrameBaseVideoNum !== dstFrameBaseVideoNum) { // || (currentFrameNum < 12 || currentFrameNum > this.reportPcVideoFramesSchema.length-12)) {
                            // "Go to chapter" code. To omit it just delete it until break (not including break)
                            let dstZoneRightMargin = dstFrameNum
                            while (dstZoneRightMargin + 1 < this.videoFramesSchema.length && this.videoFramesSchema[dstZoneRightMargin + 1] === dstFrameBaseVideoNum)
                                dstZoneRightMargin += 1
                            let dstZoneLeftMargin = dstFrameNum
                            while (dstZoneLeftMargin - 1 > 0 && this.videoFramesSchema[dstZoneLeftMargin - 1] === dstFrameBaseVideoNum)
                                dstZoneLeftMargin -= 1
                            dstFrameNum = (dstZoneRightMargin + dstZoneLeftMargin) / 2
                            break
                        } else
                            dstFrameNum = dstFrameNum + Math.sign(this.stepFramesQty)
                    }
                }

                let dstTime = frameNumToTime(dstFrameNum, this.fps)
                this.VjsPlayer.currentTime(dstTime)
                // sleep(400) /// for debug of exact frame number fbf move
                // printSeparated(dstTime, 'dstTime')
                // printSeparated(this.VjsPlayer.currentTime(), 'this.VjsPlayer.currentTime()')
            }
        }
    });

    function framebyframe(options) {
        var player = this

        player.ready(function () {
            let buttons = [{text: '↤', stepFramesQty: -1, class: 'fbf-backward', tip: '1 frame backward'},
                {text: '↦', stepFramesQty: 1, class: 'fbf-forward', tip: '1 frame forward'}]
            buttons.forEach(function (buttonOptions) {
                let button = new FBFButton(player, {
                    el: videojs.dom.createEl(
                        'button',
                        {
                            className: 'vjs-button vjs-control vjs-fbf-button ' + buttonOptions.class,
                            innerHTML: '<div class="vjs-control-content"><span class="vjs-fbf-span"><b>' + buttonOptions.text + '</b></span></div>',
                            title: buttonOptions.tip
                        },
                        {
                            role: 'button'
                        }
                    ),
                    stepFramesQty: buttonOptions.stepFramesQty,
                    fps: options.fps,
                    videoFramesSchema: options.videoFramesSchema
                })
                player.controlBar.addChild(button, {}, buttonOptions.index);
                player.controlBar.el().insertBefore(button.el(), player.controlBar.progressControl.el())
            })
        });
    }

    videojs.registerPlugin('framebyframe', framebyframe)

    function keyTsMarkers(options) {
        var player = this
        player.TMMarkers = []

        function setMarkers() {
            let markers = player.el().getElementsByClassName('vjs-marker')
            while (markers.length)
                markers[0].remove()

            var framesSchema = options.videoFramesSchema

            function addMarker(frameNumAbs, tip, smallFlag) {
                let frameNum = Math.floor((framesSchema.indexOf(frameNumAbs) + framesSchema.lastIndexOf(frameNumAbs)) / 2)
                let playheadWell = player.el().getElementsByClassName('vjs-progress-holder')[0]
                let elem = document.createElement('div')
                elem.className = 'vjs-marker vjs-icon-circle'
                if (smallFlag)
                    elem.className += ' vjs-marker-small'
                elem.style.left = frameNum / (framesSchema.length - 1) * 100 + "%"
                elem.title = tip
                playheadWell.appendChild(elem)
            }

            let strokes = options.strokes

            if (strokes && framesSchema) {
                let tip = `Stroke ${strokes[0].num} start catch`
                addMarker(strokes[0].start_frame_num, tip)
                for (let stroke of strokes) {
                    tip = `Stroke ${stroke.num} finish`
                    addMarker(stroke.finish_frame_num, tip, true)
                    tip = `Stroke ${stroke.num} end catch`
                    addMarker(stroke.end_frame_num, tip)
                }
            }
        }

        player.ready(setMarkers)
        player.on('sourceChangedBySetSource', setMarkers)
    }

    videojs.registerPlugin('keyTsMarkers', keyTsMarkers)


    function modifier() {
        var player = this
        player.ready(function () {
            player.controlBar.el().insertBefore(player.controlBar.playbackRateMenuButton.el(), player.controlBar.progressControl.el());
        })

        player.isPlaying = false
        player.on(['waiting', 'pause'], function () {
            player.isPlaying = false
        })

        player.on('playing', function () {
            player.isPlaying = true
        })
    }

    videojs.registerPlugin('modifier', modifier);

    export default {
        mixins: [fileUtils],
        props: {
            videoFileId: {},
            posterFileId: {},
            videoFramesSchema: {},
            reportSrcVideoFramesSchema: {},
            doPreload: {},
            strokes: {},
            reportSrcVideoInitialTime: {},
            playersSyncState: Object,
            needSync: Boolean,
            enableDrawingOverlay: Boolean,
        },
        data() {
            return {
                VjsPlayer: null,
                drawingOverlay: null,
                // reloadOnError: 2,
                fps: 25,
                playersSyncCode: '',
                receivedSyncCode: '',
                inPreloading: false,
                skipEvents: [],
            }
        },
        methods: {
            async initPlayer() {
                let options = {
                    sources: [{
                        type: 'video/mp4',
                        src: this.fileUrl(this.videoFileId)
                    }],
                    poster: this.needSync ? null : this.fileUrl(this.posterFileId),
                    preload: this.doPreload ? 'auto' : 'none',
                    controls: true,
                    playbackRates: [0.1, 0.2, 0.5, 1],
                    fluid: true,
                    plugins: {
                        framebyframe: {
                            fps: this.fps,
                            videoFramesSchema: this.videoFramesSchema
                        },
                        keyTsMarkers: {
                            strokes: this.strokes,
                            videoFramesSchema: this.videoFramesSchema,
                        },
                        modifier: {},
                    },
                    muted: true
                }
                await sleep(Math.random()*200)
                this.VjsPlayer = videojs(this.$refs.RowingVideoPlayer, options)
                var component = this
                // var reloadOnError = this.reloadOnError
                // this.VjsPlayer.on('error', function() {
                //     if (reloadOnError) {
                //         this.VjsPlayer.dispose()
                //         this.VjsPlayer
                //     }
                // });
                var videoFramesSchema = this.videoFramesSchema
                var reportSrcVideoFramesSchema = this.reportSrcVideoFramesSchema
                var fps = this.fps

                let srcToVideoFrameNumsSchema = null

                if (videoFramesSchema && reportSrcVideoFramesSchema) {
                    srcToVideoFrameNumsSchema = []
                    for (let baseFrameNum of reportSrcVideoFramesSchema) {
                        try {
                            let q = Math.round(getAllIndices(videoFramesSchema, baseFrameNum).reduce((a, v, i) => (a * i + v) / (i + 1)));
                            srcToVideoFrameNumsSchema.push(q)
                        } catch (e) {
                            //Skip the error for comparing
                            if (!this.needSync) console.error(e);
                        }
                    }
                }

                function emitTimestampFunction () {
                    if (videoFramesSchema && reportSrcVideoFramesSchema) {
                        let currentTime = this.currentTime()
                        if (currentTime < 1 / fps - 0.00001) {
                            component.$emit('timeSet', null)
                            return
                        }

                        let framesQty = videoFramesSchema.length
                        let currentFrameNum = timeToFrameNum(currentTime, fps)
                        if (currentFrameNum > framesQty - 1)
                            currentFrameNum = framesQty - 1

                        let reportSrcVideoFrameNum = reportSrcVideoFramesSchema.indexOf(videoFramesSchema[currentFrameNum])
                        let reportSrcVideoTime = frameNumToTime(reportSrcVideoFrameNum, fps, true)
                        component.$emit('timeSet', round(reportSrcVideoTime, 2))
                    } else {
                        component.$emit('timeSet', null)
                    }
                }

                function emitIsPlay(event) {
                    if (!isSyncChanged(event.type)) {
                        return;
                    }
                    let state = getPlayerSyncState();
                    state.isPlaying = true;

                    //simulate seeking in the current player as other players do it
                    if (state.time !== 0) {
                        component.addEventSkip('seeked');
                        component.addEventSkip('playing');
                        component.VjsPlayer.currentTime(state.time - 0.001);
                    }

                    //compensate for the average data transfer delay time between players
                    state.time = state.time + 0.009;
                    DEBUG && console.log(event.type, component.videoFileId, state)
                    component.$emit('playersSync', state);
                }

                function emitPlayersSync(event) {
                    emitTimestampFunction.bind(this)();
                    if (!isSyncChanged(event.type)) {
                        return;
                    }
                    DEBUG && console.log(event.type, component.videoFileId, getPlayerSyncState())
                    component.$emit('playersSync', getPlayerSyncState());
                }

                function isSyncChanged(eventType) {
                    if (!component.needSync) {
                        return false;
                    }

                    if (!component.VjsPlayer.userActive()) {
                        return false;
                    }

                    if (component.isSkipEvent(eventType)) {
                        return false;
                    }

                    component.updateSyncCode();

                    if (!component.syncStateIsValid(component.playersSyncState)) {
                        return true;
                    }

                    return component.playersSyncCode !== component.playersSyncState.code;
                }

                function getPlayerSyncState() {
                    return {
                        "isPlaying": component.VjsPlayer.isPlaying,
                        "time": component.VjsPlayer.currentTime(),
                        "rate": component.VjsPlayer.playbackRate(),
                        "code": component.playersSyncCode,
                    };
                }

                if (srcToVideoFrameNumsSchema && this.reportSrcVideoInitialTime) {
                    let reportSrcVideoInitialTimeFloat = parseFloat(this.reportSrcVideoInitialTime)
                    let dstReportSrcVideoFrameNum = timeToFrameNum(reportSrcVideoInitialTimeFloat, this.fps)
                    let dstVideoFrameNum = srcToVideoFrameNumsSchema[dstReportSrcVideoFrameNum]
                    let dstTime = frameNumToTime(dstVideoFrameNum, this.fps)

                    this.VjsPlayer.ready(async function () {
                        await sleep(200)
                        this.play()
                        await sleep(300)
                        while (!this.isPlaying) {
                            await sleep(100)
                        }
                        this.pause()
                        while (this.isPlaying) {
                            await sleep(100)
                        }
                        this.one('seeked', function () {
                            this.on('pause', emitPlayersSync)
                            this.on('seeked', emitPlayersSync)
                            this.on('ratechange', emitPlayersSync)
                            this.on('playing', emitIsPlay)
                        })

                        this.currentTime(dstTime)
                    })
                } else {
                    this.VjsPlayer.on('pause', emitPlayersSync)
                    this.VjsPlayer.on('seeked', emitPlayersSync)
                    this.VjsPlayer.on('ratechange', emitPlayersSync)
                    this.VjsPlayer.on('playing', emitIsPlay)
                }

                this.setupDrawingOverlay()
            },
            setupDrawingOverlay() {
                if (!this.enableDrawingOverlay || !this.VjsPlayer || this.drawingOverlay) {
                    return;
                }
                this.drawingOverlay = createDrawingOverlay({
                    playerRootEl: this.VjsPlayer.el(),
                    videoElement: this.$refs.RowingVideoPlayer,
                    requestFullscreenOnOpen: true,
                });
            },
            teardownDrawingOverlay() {
                if (!this.drawingOverlay) {
                    return;
                }
                this.drawingOverlay.destroy();
                this.drawingOverlay = null;
            },
            syncStateIsValid(state = null) {
                if (!state) {
                    state = this.playersSyncState;
                }

                if (typeof state !== 'object'
                    || typeof state.isPlaying === 'undefined'
                    || typeof state.time === 'undefined'
                    || typeof state.rate === 'undefined'
                    || typeof state.code === 'undefined'
                ) {
                    return false;
                }
                return true;
            },
            updateSyncCode() {
                let date = (new Date());
                this.playersSyncCode = date.getHours().toString()
                    +':'+date.getMinutes().toString()
                    +':'+date.getSeconds().toString()
                    +':'+date.getMilliseconds().toString();
            },
            isSkipEvent(eventType) {
                let result = this.skipEvents.includes(eventType);
                if (result) {
                    let index = this.skipEvents.indexOf(eventType);
                    this.skipEvents.splice(index, 1);
                }
                return result;
            },
            addEventSkip(eventType) {
                this.skipEvents.push(eventType);
            }
        },
        mounted() {
            this.$nextTick(this.initPlayer)
        },
        beforeDestroy() {
            this.teardownDrawingOverlay()
            if (this.VjsPlayer) {
                this.VjsPlayer.dispose()
            }
        },
        watch: {
            playersSyncState: function (state) {
                if (!this.syncStateIsValid(state) || state.code === this.playersSyncCode) {
                    return;
                }

                this.VjsPlayer.userActive(false);
                this.playersSyncCode = state.code;
                this.VjsPlayer.playbackRate(state.rate);
                this.VjsPlayer.currentTime(state.time);

                if (this.VjsPlayer.readyState() < 1) {
                    this.inPreloading = true;
                }

                if (this.VjsPlayer.isPlaying !== state.isPlaying) {
                    state.isPlaying ? this.VjsPlayer.play() : this.VjsPlayer.pause();
                }
            },
            doPreload: function (state) {
                if (state === 'auto') {
                    this.VjsPlayer.preload = state;
                }
            },
            enableDrawingOverlay: function (enabled) {
                if (enabled) {
                    this.setupDrawingOverlay();
                } else {
                    this.teardownDrawingOverlay();
                }
            }
        }
    }
</script>
<!--suppress CssUnusedSymbol -->
<style>

    @media only screen and (max-width: 576px) {

        .vjs-playback-rate, .vjs-fullscreen-control, .vjs-play-control {
            width: 2.5em !important;
        }

    }

    .video-js .vjs-fbf-button {
        width: 2em !important;
        font-size: 1.5em;
    }

    .video-js .fbf-forward {
        width: 1.45em !important;
        margin-right: 0.2em !important;
    }

    .vjs-play-control {
        margin-right: -0.2em !important;
    }

    .video-js .fbf-backward {
        width: 1.45em !important;
        margin-left: 0.2em !important;
    }

    .video-js .vjs-volume-panel {
        display: none !important;
    }

    .vjs-playback-rate {
        font-size: 0.9em !important;
        margin-top: 0.1em !important;
        margin-left: 0.3em !important;
        margin-right: 0.3em !important;
    }

    .vjs-src-value {
        margin-top: 0.7em;
        pointer-events: none;
        font-size: 0.9em;
        line-height: 2;
        text-align: center;
        margin-bottom: -2.8em;
        font-weight: bold;
    }

    .vjs-src-menu-button {
        margin-left: 0.35em !important;
        margin-right: 0.3em !important;
    }

    .vjs-marker {
        position: absolute;
        opacity: 0.3;
        margin-top: -0.3em;
        font-size: 0.8em;
        margin-left: -0.4em;
    }

    .vjs-marker-small {
        margin-top: -0.2em;
        font-size: 0.4em;
        margin-left: -0.4em;
    }

    .vjs-progress-control:hover .vjs-marker {
        margin-top: -0.25em;
        font-size: 0.6em;
        margin-left: -0.3em;
        opacity: 0.5;
    }

    .vjs-progress-control:hover .vjs-marker-small {
        margin-top: -0.05em;
        font-size: 0.3em;
        margin-left: -0.3em;
    }

    .rowing-video-player .vjs-time-tooltip, .rowing-video-player .vjs-load-progress, .rowing-video-player .vjs-remaining-time {
        display: none !important;
    }

    .compare .vjs-user-inactive.vjs-paused .vjs-control-bar {
        visibility: visible;
        opacity: 0;

        $trans: visibility 1.0s, opacity 1.0s;
        @include transition($trans);
    }
    @media (max-width: 992px) {
        .video-container__player-wrapper .video-js .vjs-big-play-button {
            transform: scale(0.5);
        }
    }
</style>
